module.exports = __webpack_public_path__ + "static/evaksine_screen-a5761f48f51db4fbabbbb26e9acfd2eb.jpg";